import "./ScreenReaderOnlyText.scss";
import { BlockTopProps } from "/Models/Generated/BlockTopProps";

interface Props extends BlockTopProps {
  text?: string;
  ariaLive?: "polite" | "off" | undefined;
}

const ScreenReaderOnlyText = ({ text, ariaLive = "off" }: Props) => (
  <div className="screen-reader-only-text-norad" aria-live={ariaLive}>
    {text}
  </div>
);

export default ScreenReaderOnlyText;
